import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./featureHrms.css";
import BookDemoModal from "../../landing-hrms/sections/DemoModal";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { colors } from "@mui/material";

const FeatureOfHrms = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const features = [
    {
      icon: "bi-people",
      colors: '#0085FF',
      title: "Staff Management",
      desc: "Biodata and personal information of employees.",
    },
    {
      icon: "bi-person-plus",
      colors: '#DD4F24',
      title: "Onboarding",
      desc: "View offer letters and contracts through the mobile app.",
    },
    {
      icon: "bi-box-seam",
      colors: '#FBB034',
      title: "Assets Management",
      desc: "Track assets assigned to staff, loans, insurance, and more.",
    },
    {
      icon: "bi-mortarboard",
      colors: '#FF6D01',

      title: "Training Management",
      desc: "Assign training programs and issue certificates.",
    },
    {
      icon: "bi-graph-up-arrow",
      colors: '#34A853',
      title: "Career Progression",
      desc: "Monitor promotions, raises, bonuses, and education.",
    },
    {
      icon: "bi-cash-coin",
      colors: '#00CD37',
      title: "Increment & Bonus",
      desc: "Simple bonus proposal, approval, and payroll integration.",
    },
    {
      icon: "bi-calculator",
      colors: '#ff2701',
      title: "Payroll Processing",
      desc: "Complete payroll in 3 simple steps and generate payslips.",
    },
    {
      icon: "bi-box-arrow-right",
      colors: '#ff01c8',
      title: "Offboarding",
      desc: "Manage exit procedures, checklists, and employee feedback.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          HRMS Software Features | Payroll, Attendance & HR Automation | TechCognics
        </title>

        <meta
          name="description"
          content="Explore powerful HRMS software features including payroll automation, attendance tracking, leave management, compliance tools, and employee self-service to simplify HR operations."
        />

        <meta
          name="keywords"
          content="HRMS features, HR software modules, payroll features, attendance management features, HR automation tools, HRMS payroll system, cloud HR software"
        />

        <meta
          property="og:title"
          content="HRMS Software Features | Payroll, Attendance & HR Automation"
        />

        <meta
          property="og:description"
          content="Discover smart HRMS features designed to automate payroll, attendance, onboarding, and workforce management efficiently."
        />

        <meta property="og:type" content="website" />
      </Helmet>

      <section id="features" className="work-process-area__one section-padding">
        <div className="container">
          <div className="row justify-content-center gy-4">
            {/* Heading */}
            <div className="site-heading text-center mb-4">
              <div className="text-center feature-heading" style={{ color: '#0F4F93' }}>Feature of HR software</div>

              <p>
                Smart features designed to support your workforce at every step.
              </p>
            </div>
            {features.map((item, index) => (
              <div key={index} className="col-xl-3 col-md-6">
                <div className="work-process-area__one-single-work">

                  {/* ICON */}
                  <span className="feature-icon" style={{ color: item.colors, borderRadius: '50%' }}>
                    <i className={`bi ${item.icon}`}></i>
                  </span>

                  <div className="work-process-area__one-single-work-content">
                    <h5>{item.title}</h5>
                    <p className="text-center" style={{ fontSize: '12px', fontWeight: '500', lineHeight: '1.4' }}>{item.desc}</p>
                  </div>

                </div>
              </div>
            ))}
          </div>
          <button onClick={() => setShowContactModal(true)} className="btn-two mt-4">
            Book Demo <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
          </button>
        </div>
      </section>
      <BookDemoModal
        showDemo={showContactModal}
        handleDemoClose={() => setShowContactModal(false)}
      />

    </>

  );

};

export default FeatureOfHrms;
